
import React from 'react';
import { GenerateTemplate } from 'themes/application/schedule/components';
import { observer } from 'mobx-react';
import {setCurrentView} from 'core/utils';
import {GenerateStore} from 'application/schedule/stores';

@setCurrentView((rootStore, componentProps) => new GenerateStore(rootStore, componentProps), 'generateStore')
@observer
class Generate extends React.Component {
    render() {
        return <GenerateTemplate {...this.props} />
    }
}

export default Generate;
